function Flower2(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M360 240a120 120 0 1 0-120-120 120 120 0 1 0-120 120 120 120 0 1 0 120 120 120 120 0 1 0 120-120Zm-120 60a60 60 0 1 1 0-120 60 60 0 0 1 0 120Z"></path></svg>
    )
}

export default Flower2